import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const GiftSolidIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M19.69 6.094h-1.47a3.56 3.56 0 0 0-.16-2.5a3 3 0 0 0-3-1.61A3.38 3.38 0 0 0 12 3.574a3.5 3.5 0 0 0-.47-.59a3.54 3.54 0 0 0-2.63-1a3.07 3.07 0 0 0-3 1.62a3.58 3.58 0 0 0-.16 2.49H4.29A2.3 2.3 0 0 0 2 8.384v2a2.31 2.31 0 0 0 2.06 2.29v6.55a2.82 2.82 0 0 0 2.8 2.81h10.28a2.82 2.82 0 0 0 2.8-2.81v-6.5a2.31 2.31 0 0 0 2.06-2.29v-2a2.3 2.3 0 0 0-2.31-2.34m-4.63-2.61a1.67 1.67 0 0 1 1.63.74a2.27 2.27 0 0 1-.1 1.84h-3.86c.22-2.58 1.78-2.58 2.31-2.58zm-7.83.78a1.67 1.67 0 0 1 1.67-.78a2.1 2.1 0 0 1 1.56.55a3.22 3.22 0 0 1 .75 2.06H7.32a2.3 2.3 0 0 1-.11-1.87zm-3.75 6.17v-2a.79.79 0 0 1 .79-.79h7v3.58h-7a.79.79 0 0 1-.81-.79zm17 0a.79.79 0 0 1-.79.8h-7v-3.64h7a.79.79 0 0 1 .79.79z"
      />
    </svg>
  );
};

export default GiftSolidIcon;
